"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tribunalCaseTypesByCountry = exports.TribunalCaseStatus = exports.TribunalCaseType = void 0;
const __1 = require("../..");
const denmark_1 = require("./countries/denmark");
const greenland_1 = require("./countries/greenland");
exports.TribunalCaseType = Object.assign(Object.assign({}, denmark_1.DKTribunalCaseType), greenland_1.GLTribunalCaseType);
var TribunalCaseStatus;
(function (TribunalCaseStatus) {
    TribunalCaseStatus["Created"] = "CREATED";
    TribunalCaseStatus["Closed"] = "CLOSED";
    TribunalCaseStatus["Awaiting1Paategning"] = "AWAITING1PAATEGNING";
    TribunalCaseStatus["Awaiting2Paategning"] = "AWAITING2PAATEGNING";
    TribunalCaseStatus["AwaitingNoticeForBailiffMeeting"] = "AWAITINGNOTICEFORBAILIFFMEETING";
    TribunalCaseStatus["AwaitingBailiffMeeting"] = "AWAITINGBAILIFFMEETING";
    TribunalCaseStatus["ClosedBecauseOfObjection"] = "CLOSEDBECAUSEOFOBJECTION";
    TribunalCaseStatus["AwaitingVerdict"] = "AWAITINGVERDICT";
    TribunalCaseStatus["AwaitingNoticeForFogedmoede"] = "AWAITINGNOTICEFORFOGEDMOEDE";
    TribunalCaseStatus["AwaitingFogedmoede"] = "AWAITINGFOGEDMOEDE";
})(TribunalCaseStatus || (exports.TribunalCaseStatus = TribunalCaseStatus = {}));
exports.tribunalCaseTypesByCountry = {
    [__1.CountryCode.DK]: denmark_1.DKTribunalCaseType,
    [__1.CountryCode.GL]: Object.assign(Object.assign({}, greenland_1.GLTribunalCaseType), denmark_1.DKTribunalCaseType),
};
//# sourceMappingURL=types.js.map